import AbstractItemResource from "../abstract/abstract-item-resource"
import defines from "dpsdk/defines"
const {Resource, DetectionProfileAllowedDirection} = defines
import Zone from './zone'
import api from '../../api'
import iso from "iso-3166-1"
import countries from "i18n-iso-countries"

class VehicleLog extends AbstractItemResource {
    constructor(data, parent) {
        super(Resource.VEHICLE_LOGS, data, parent)
        this.setLabels({
            id: 'ID'
        })
    }

    getFileRoute(filename = null) {
        if (!filename) {
            filename = this.photo_filename
        }
        return `/${Resource.VEHICLE_LOGS.toLowerCase()}/${this.id}/files/${filename}`
    }

    getReportRoute() {
        return `/${Resource.VEHICLE_LOGS.toLowerCase()}/${this.id}/download`
    }

    openFile(filename = null) {
        return api.openBlob(this.getFileRoute(filename))
    }

    downloadReport() {
        const baseName = (this.photo_filename || 'report').replace(/\.(jpe?g|png|gif|zip)$/i, '')
        return api.downloadBlob(this.getReportRoute(), `${baseName}.zip`, {
            photo_filename: this.photo_filename
        })
    }

    getDetails() {
        return api.get(`/${Resource.VEHICLE_LOGS.toLowerCase()}/${this.id}/details`)
    }

    getDirectionStr(t) {
        switch (this.direction) {
            case DetectionProfileAllowedDirection.OPPOSITE:
                return t('vehicleLogs.opposite')
            case DetectionProfileAllowedDirection.PASSING:
                return t('vehicleLogs.passing')
            default:
                return t('vehicleLogs.unknown')
        }
    }

    getViolationsStr(t) {
        if (!this.violations || this.violations === '0') {
            return `C0 - ${t('vehicleLogs.noViolations')}`
        }

        const arr = this.violations.split(',')

        return arr.map(el => {
            return `${Zone.violationStr(t, parseInt(el))}`
        }).join(', ')
    }

    sizeClassStr(t) {
        return this.size_class || t('vehicleLogs.unknown')
    }

    countryStr(t, language) {
        const isoItem = iso.whereNumeric(this.country) || iso.whereNumeric(`0${this.country}`) || iso.whereNumeric(`00${this.country}`)
        if (isoItem) {
            return countries.getName(isoItem.alpha2, language) || isoItem.country
        }

        return t('vehicleLogs.unknown')
    }

    vehicleTypeStr(t) {
        if (this.truck_type !== undefined && this.truck_type !== null) {
            const el = this.parent.typesForDropDown(t).find((el) => el.value.toString() === this.truck_type.toString())
            if (el) {
                return el.label
            }
        }

        return t('vehicleLogs.unknown')
    }

    truckCargoTypeStr(t) {
        return t(`vehicleLogs.truckCargoType.${this.truck_cargo_type}`)
    }

    truckBodyTypeStr(t) {
        return t(`vehicleLogs.truckBodyType.${this.truck_body_type}`)
    }

    colorStr(t) {
        return t(`vehicleLogs.color.${this.color}`)
    }
}

export default VehicleLog
